import { Component, ElementRef, OnInit, Output, EventEmitter} from '@angular/core';
import { PopoverController } from '@ionic/angular'
import { ResourcesProvider } from '../../providers/resources/resources.provider';
import { TeacherProvider } from '../../providers/teacher/teacher.provider';
import { Teacher } from '../../models/teacher';
import { Article } from '../../models/article';
import { TeachingTool } from '../../models/teaching-tool';
import { ResourcesBase } from '../resources/resources-base.page';
import { ResourcesCssService } from '../resources/resources-css.service'
import { WindowService } from '../../services/window.service'
import { TeacherStore } from 'src/app/stores/teacher.store';
import { Subject, map, takeUntil } from 'rxjs';
import { Resources } from 'src/app/models/resources';
import { ResourceStore } from 'src/app/stores/resources.store';

@Component({
  selector: 'app-teacher-notes',
  templateUrl: './teacher-notes.page.html',
  styleUrls: ['./teacher-notes.page.scss'],
})
export class TeacherNotesPage extends ResourcesBase<TeachingTool> implements OnInit {

  teacher: Teacher = Teacher.defaults();

  sidebarContent: string = `<p>Regular posts to the Blog cover a range of topics including 
                            classroom management, PEMs, learning and leading patterns, and much more. 
                            Have a topic you’d like us to cover?<br/><br/>
                            Let us know:
                            <a href='mailto:teacherblog@musictogether.com'>teacherblog@musictogether.com</a>
                            </p>`;

  ngUnsubscribeTeacher = new Subject();

  _currentPage: number
  itemsPerPage: number
  @Output() currentPageChanged = new EventEmitter<number>()

  constructor(element: ElementRef,
              resourcesProvider: ResourcesProvider,
              private teacherProvider: TeacherProvider,
              resourcesCssService: ResourcesCssService,
              windowService: WindowService,
              private teacherStore: TeacherStore,
              protected resourceStore: ResourceStore) {
    super(element, resourcesProvider, resourcesCssService, windowService, resourceStore)

    this.teacher = this.teacherProvider.teacher;
    this.teacherStore.state$
        .pipe(takeUntil(this.ngUnsubscribeTeacher))
        .subscribe(() => {
          this.teacher = this.teacherProvider.teacher;
        });

    resourcesProvider.getResources().subscribe(resources => {
      this.resourcesUpdated(resources);
    })

  }

  ngOnInit() {
    super.ngOnInit()
    this._currentPage = 1
    this.itemsPerPage = 10

    const t = this
    navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
        const interval = setInterval(() => {
            const pageElement = document.querySelector(t.element.nativeElement.tagName + '.ion-page:not(.ion-page-invisible)') as Element
            if (pageElement) {
                clearInterval(interval)
            }
        }, 500)
    });
  }

  ngOnDestroy(){
    this.ngUnsubscribeTeacher.next(true);
    this.ngUnsubscribeTeacher.complete();
  }

  resourcesUpdated(resources: Resources): void {
    const callout = resources.findCallout('teacher-notes-sidebar');
    if (callout && callout.content) {
      this.sidebarContent = callout?.content
    }
  }

  get notes(): any[] {

    return this.listItems

    // if (this.listItems !== undefined) {
    //   const lowerIndex = (this._currentPage - 1) * this.itemsPerPage
    //   const upperIndex = (this._currentPage * this.itemsPerPage) - 1

    //   return this.listItems.map((value: any, index: number) => {
    //     if (index >= lowerIndex && index <= upperIndex) {
    //       return value
    //     }
    //   }).filter(x => x !== undefined)
    // }
    // return []
  }

  // get articles(): Article[] }


  items(): any[] {
    return this.teacher?.articles || []
  }

  isArticle(model: any) {
    return true
  }

  itemMatchesSearch(item: any, searchString: string): boolean {
    return (!this.isArticle(item) && (item.name.toLowerCase().indexOf(searchString.toLowerCase()) >= 0 ||
          item.description.toLowerCase().indexOf(searchString.toLowerCase()) >= 0))
          || (this.isArticle(item) && (item.title.toLowerCase().indexOf(searchString.toLowerCase()) >= 0 ||
          item.summary.toLowerCase().indexOf(searchString.toLowerCase()) >= 0))
  }

  itemsSortedBy(items: any[], option: string) {
    // Sort by `order` property
    return items.sort((a: any, b: any) => {
      if (parseInt(a.order) < parseInt(b.order))
        return -1
      if (parseInt(a.order) > parseInt(b.order))
        return 1
      return 0
    })  
  }

  // Pagination functions
  previousPage() {
    if (this._currentPage > 1) {
      this._currentPage--
    }
  }

  nextPage() {
    if (this._currentPage < this.totalPages) {
      this._currentPage++
    }
  }

  goToPageIndex(index: number) {
    if (index >= 1 && index <= this.totalPages) {
      this._currentPage = index
    }
  }

  get currentPage(): number { return this._currentPage }
  set currentPage(value: number) {
    if (value >= 1 && value <= this.totalPages) {
      this._currentPage = value
      this.currentPageChanged.emit(value)
    }
  }

  get totalItems(): number {
    return this.items.length
  }

  get totalPages(): number {
      return Math.floor((this.totalItems / this.itemsPerPage) + (this.totalItems % this.itemsPerPage > 0 ? 1 : 0))
  }

  get prevClass(): string {
    return this.currentPage === 1 ? 'disabled' : '';
  }

  get nextClass(): string {
    return this.currentPage === this.totalPages ? 'disabled' : '';
  }


}
